import { render, staticRenderFns } from "./fpzLiabilitySearch.vue?vue&type=template&id=fb4938ce"
import script from "./fpzLiabilitySearch.vue?vue&type=script&lang=js"
export * from "./fpzLiabilitySearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports